export enum Periodicity {
  Unknown = 0,
  MONTH = 1,
  SEMESTER = 2,
  TRIMESTER = 3,
  YEAR = 4,
}
